import {
  GET_JOB_POSITION_CATALOG,
  GET_JOB_POSITION_CATALOG_SUCCESS,
  GET_JOB_POSITION_CATALOG_ERROR,
} from '../../../../constants/constantsRed';

export const getJobPositionCatalogRed = (
  state: any,
  actions: any
) => {
  switch (actions.type) {
    case GET_JOB_POSITION_CATALOG:
      return {
        ...state,
        loading: true,
      };
    case GET_JOB_POSITION_CATALOG_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    case GET_JOB_POSITION_CATALOG_ERROR:
      return {
        data: null,
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};
